<template>
  <div class="corpo-pagina home">

    <div class="row row-text">
      <div class="col s9 m9 l9">
        <h4 class="event-title">{{ translation('title.list.event.page') }}</h4>
      </div>

      <!-- su phone la colonna diventa s12 e va sotto -->
      <div class="col s12 m3 l3 new-event-col">
      <router-link
          class="btn-large new-event-btn"
          @click="pageLoading"
          to="/new-event"
        >
  <i class="material-icons left">add_circle_outline</i>
  {{ translation('btn.new.event') }}
</router-link>
      </div>
    </div>

    <div class="divider"></div>

    <div class="row">
      <div class="col s12 m5 l5 xl5">

          <div class="col s6 m6 l6 xl6">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">today</i>
          <input id="date_start"
                 type="text"
                 class="datepicker required"
                 v-model="evetnModel.event_date_start"
                 autocomplete="off" />
                <span class="clear-icon" v-if="date_from" @click="clearDateFrom">
                    <i class="material-icons">close</i>
                </span>
          <label for="date_start">{{ translation('event.date.field') }}</label>
        </div>
      </div>

         <div class="col s6 m6 l6 xl6">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">today</i>
          <input id="date_finish"
                 type="text"
                 class="datepicker required"
                 v-model="evetnModel.event_date_finish"
                 autocomplete="off" />
              <span class="clear-icon" v-if="date_at" @click="clearDateAt">
                <i class="material-icons">close</i>
              </span>
          <label for="date_finish">{{ translation('event.date.field.finish') }}</label>
        </div>
      </div>
      </div>

      <div class="col s12 m5 l5 xl5">
         <div class="input-field col s12">
          <i class="material-icons prefix">search</i>
          <input v-model="search_term" type="text" id="autocomplete-input" class="autocomplete">
          <span class="clear-icon" v-if="search_term" @click="clearSearch">
            <i class="material-icons">close</i>
          </span>
          <label for="autocomplete-input">{{ translation('campo.cerca.eventi') }}</label>
        </div>

      </div>

      <div class="col s12 m2 l2 xl2 new-event-col">
          <a class="btn-large new-event-btn"  @click="listEvents" href="#"><i class="material-icons prefix">search</i></a>
      </div>

    </div>

    <div class="row">
      <CardEvent v-for="eventData in events" :key="eventData.uid" :event="eventData" />
    </div>

    <div class="divider"></div>

    <div v-if="totalPages > 0">
      <PaginationControls
        :currentPage="currentPage"
        :totalPages="totalPages"
        :itemsPerPage="itemsPerPage"
        :strPerPag="translation('paginator.event.per.page')"
        :strPag="translation('per.page')"
        @page-changed="handlePageChange"
        @items-per-page-changed="handleItemsPerPageChange"
      />
    </div>

    <div v-if="events.length === 0" class="row">
      <div class="col s12">
        <p>{{ translation('no.events.list') }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import translationStore from '@/store/translations'
import CardEvent from '@/components/CardEvent.vue'
import PaginationControls from '@/components/PaginationControls.vue'
import apiService from '@/services/apiService.js'
import useAuthStore from '@/store/authStore.js'
import { userCallingModel } from '@/models/userCalling.js'
import loadingStore from '@/store/loading'
import eventSetting from '@/store/eventSettings.js'
import M from 'materialize-css'
import { evetnModel } from '@/models/eventModel.js'

export default {
  name: 'app',

  components: {
    CardEvent,
    PaginationControls
  },

  data () {
    return {
      translationStore,
      events: [],
      useAuthStore,
      userCallingModel,
      evetnModel: { ...evetnModel }, // Crea una copia per evitare modifiche dirette allo store
      currentPage: 0,
      totalPages: null,
      itemsPerPage: 10,
      pageChanges: false,
      eventSetting,
      search_term: null,
      date_from: null,
      date_at: null,

      // responsive
      viewportW: window.innerWidth
    }
  },

  computed: {
    translation () {
      return this.translationStore.getters.traduzione
    },

    // Breakpoints Materialize: s <=600, m 601-992, l >=993
    isMobile () {
      return this.viewportW <= 600
    },
    isTablet () {
      return this.viewportW >= 601 && this.viewportW <= 992
    },
    isDesktop () {
      return this.viewportW >= 993
    },

    // Classe bottone davvero variabile per display
    newEventBtnClass () {
      if (this.isDesktop) {
        return 'btn-large new-event-btn'
      }
      if (this.isTablet) {
        return 'btn new-event-btn'
      }
      // mobile: full width
      return 'btn new-event-btn btn-block'
    }
  },

  methods: {

    clearSearch () {
      this.search_term = null
      this.listEvents()
    },
    clearDateFrom () {
      this.date_from = null
      this.evetnModel.event_date_start = null
      this.listEvents()
    },
    clearDateAt () {
      this.date_at = null
      this.evetnModel.event_date_finish = null
      this.listEvents()
    },

    onResize () {
      this.viewportW = window.innerWidth
    },

    pageLoading () {
      loadingStore.commit('setLoading', true)
    },

    handlePageChange (page) {
      if (page !== this.currentPage) this.currentPage = page
      this.pageChanges = !this.pageChanges
    },

    handleItemsPerPageChange (newItemsPerPage) {
      if (newItemsPerPage !== this.itemsPerPage) {
        this.itemsPerPage = newItemsPerPage
        this.currentPage = 0
      }
      this.pageChanges = !this.pageChanges
    },

    async listEvents () {
      loadingStore.commit('setLoading', true)
      this.eventSetting.dispatch('resetEvents')

      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
        return
      }

      const url = process.env.VUE_APP_URL_EVENTS + '/events/list'

      await this.userCallingModel.costruttore(
        this.useAuthStore.getters.userInfo,
        this.currentPage,
        this.itemsPerPage,
        this.totalPages,
        null,
        this.search_term,
        this.date_from,
        this.date_at
      )

      const jsonEvents = await apiService.sendRequestWithBearer(
        'POST',
        url,
        token,
        this.userCallingModel,
        null
      )

      this.events = jsonEvents.content || []
      this.totalPages = jsonEvents.totalPages || 0

      loadingStore.commit('setLoading', false)
    },

    // Metodo per inizializzare SOLO Datepicker
    initMaterializeDatepickers () {
      this.$nextTick(() => {
        const timezone = this.useAuthStore.getters.timezone
        // Aggiunto controllo per timezone e time_format per evitare errori se sono null
        const timeFormat = timezone && timezone.time_format ? timezone.time_format : 'HH:mm'
        // const timeFormatOrder = 'YYYY-MM-DD'
        const optform = timeFormat.split(' ')
        const format = optform[0]

        const initDatepicker = (elementId, modelProp) => {
          const el = document.getElementById(elementId)
          if (!el) return

          const instance = M.Datepicker.getInstance(el)
          if (instance) {
            instance.destroy()
          }

          const datepickerOptions = {
            classes: '',
            autoClose: true,
            format: format.toLowerCase(),
            i18n: {
              months: [
                this.translation('months.jen'), this.translation('months.feb'), this.translation('months.mar'),
                this.translation('months.apr'), this.translation('months.may'), this.translation('months.jun'),
                this.translation('months.jul'), this.translation('months.ago'), this.translation('months.set'),
                this.translation('months.ott'), this.translation('months.nov'), this.translation('months.dic')
              ],
              monthsShort: [
                this.translation('monthsShort.jen'), this.translation('monthsShort.feb'), this.translation('monthsShort.mar'),
                this.translation('monthsShort.apr'), this.translation('monthsShort.may'), this.translation('monthsShort.jun'),
                this.translation('monthsShort.jul'), this.translation('monthsShort.ago'), this.translation('monthsShort.set'),
                this.translation('monthsShort.ott'), this.translation('monthsShort.nov'), this.translation('monthsShort.dic')
              ],
              weekdays: [
                this.translation('day.sun'), this.translation('day.mon'), this.translation('day.tue'),
                this.translation('day.wed'), this.translation('day.thu'), this.translation('day.fri'),
                this.translation('day.sat')
              ],
              weekdaysShort: [
                this.translation('day.sun.short'), this.translation('day.mon.short'), this.translation('day.tue.short'),
                this.translation('day.wed.short'), this.translation('day.thu.short'), this.translation('day.fri.short'),
                this.translation('day.sat.short')
              ],
              weekdaysAbbrev: [
                this.translation('day.sun.short').charAt(0).toUpperCase(),
                this.translation('day.mon.short').charAt(0).toUpperCase(),
                this.translation('day.tue.short').charAt(0).toUpperCase(),
                this.translation('day.wed.short').charAt(0).toUpperCase(),
                this.translation('day.thu.short').charAt(0).toUpperCase(),
                this.translation('day.fri.short').charAt(0).toUpperCase(),
                this.translation('day.sat.short').charAt(0).toUpperCase()
              ]
            },
            onSelect: (selectedDate) => {
              this.evetnModel.formatLocalISO(selectedDate)

              if (el.id === 'date_start') {
                this.date_from = this.evetnModel.order_date
              }

              if (el.id === 'date_finish') {
                this.date_at = this.evetnModel.order_date
              }

              this.evetnModel.order_date = null

              const formattedDate = M.Datepicker.getInstance(el).toString()
              this.$nextTick(() => {
                this.evetnModel[modelProp] = formattedDate
              })
            },
            onClose: () => {
              M.updateTextFields()
            }
          }

          M.Datepicker.init(el, datepickerOptions)

          if (this.evetnModel[modelProp]) {
            const pickerInstance = M.Datepicker.getInstance(el)
            if (pickerInstance) {
              const initialDate = new Date(this.evetnModel[modelProp])
              if (!isNaN(initialDate.getTime())) {
                pickerInstance.setDate(initialDate, true)
                pickerInstance.gotoDate(initialDate)
              }
            }
          }
          M.updateTextFields()
        }

        initDatepicker('date_start', 'event_date_start')
        initDatepicker('date_finish', 'event_date_finish')
      })
    }
  },

  watch: {
    pageChanges: 'listEvents',
    'translationStore.getters.linguaCorrente': {
      handler () {
        this.initMaterializeDatepickers() // Re-inizializza tutto quando cambia lingua
      },
      immediate: true
    }
  },

  mounted () {
    window.addEventListener('resize', this.onResize, { passive: true })

    this.listEvents()
    this.initMaterializeDatepickers()
    loadingStore.commit('setLoading', false)
    eventSetting.dispatch('showHeaderChange', false)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>

/* =========================
   DESKTOP
   ========================= */
.new-event-btn {
  height: 48px;              /* più basso di btn-large */
  line-height: 48px;
  padding: 0 22px;

  font-size: 0.95rem;
  border-radius: 24px;

  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* icona allineata */
.new-event-btn i {
  font-size: 1.2rem;
  line-height: 1;
}

/* =========================
   TABLET
   ========================= */
@media (max-width: 992px) {
  .new-event-btn {
    height: 44px;
    line-height: 14px;
    font-size: 0.9rem;
    padding: 0 18px;
  }
}

/* =========================
   MOBILE
   ========================= */
@media (max-width: 600px) {
  .new-event-btn {
    width: 100%;
    height: 46px;
    line-height: 46px;

    font-size: 0.95rem;
    padding: 0 16px;

    justify-content: center;
  }
}

/* Allineamento: desktop/tablet a destra, mobile centrato */
.new-event-col {
  text-align: right;
}

/* Titolo scala (opzionale ma consigliato) */
.event-title {
  margin: 0;
  font-size: 2.1rem;
  line-height: 1.25;
}

/* Full width su mobile */
.btn-block {
  width: 100%;
  display: block;
  text-align: center;
}

/* Desktop */
@media (min-width: 993px) {
  .new-event-text { font-size: 1.05rem; }
  .new-event-icon { font-size: 1.8rem; }

  .event-title { font-size: 2.2rem; }
}

/* Tablet */
@media (min-width: 601px) and (max-width: 992px) {
  .new-event-text { font-size: 0.98rem; }
  .new-event-icon { font-size: 1.6rem; }

  .event-title { font-size: 1.9rem; }
}

/* Phone */
@media (max-width: 600px) {
  .new-event-col {
    text-align: center;
    margin-top: 12px;
  }

  .new-event-text { font-size: 1rem; }
  .new-event-icon { font-size: 1.5rem; }

  .event-title {
    font-size: 1.5rem;
    text-align: center;
  }
}

.clearable {
  position: relative;
}

.clear-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
}

.clear-icon:hover {
  color: #e53935;
}

</style>
